import * as React from 'react'
import {createStyles, Grid, Theme, Typography, WithStyles, withStyles, FormControlLabel, Checkbox, RadioGroup, Radio, Icon} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {connect} from 'react-redux'
import {RootState} from 'src/core/redux/reducer/index'
import {compose} from 'redux'
import {WithGlobalProgress} from 'src/type/lib/withGlobalProgress'
import {WithToast} from 'src/type/lib/withToast'
import autobind from 'autobind-decorator'
import {withToast} from 'src/shared/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withRouter, RouteComponentProps } from 'react-router'
import { acceptCGU, fetchAccountInfos, fetchEnterpriseSelected } from 'src/core/redux/action/accountInfosAction'
import PageHead from 'src/shared/PageHead/PageHead'
import { CGU } from 'src/shared/CGU/cgu'
import Btn from 'src/shared/Btn/Btn'
import Page from 'src/shared/Page/Page'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
  cguModal: {
    marginBottom: '25px',
    overflow: 'auto'
  },
  scrollDown: {
    display: 'block',
    margin: '10px auto',
    animation: 'bounce 1s infinite'
  },
  flexCenter: {
    ...css.flexJcCenter
  }
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  RouteComponentProps<any>,
  WithToast,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}


interface IState {
  cguAccepted: boolean;
  cguReaded: boolean;
  allowMailNotifications: string | undefined;
}

class CguValidation extends React.Component<IProps, IState> {
  state = {
    cguAccepted: false,
    cguReaded: false,
    allowMailNotifications: undefined,
  } 

  render() {
    const {t, classes} = this.props
    const {cguReaded, cguAccepted, allowMailNotifications} = this.state
    return (
      <>
          <HelmetMeta title={t.App_title_page_CGU}/>
          <PageHead title={t.cgu_title} />
          <Page withHead width="80%">
              <Grid container 
                className={classes.cguModal} 
                onScroll={this.handleScroll}
                style={{
                  height: `calc(100vh - ${cguReaded ? 250 : 300}px)`,
                }}
              >
                <Grid item xs={12}>
                  <CGU />
                </Grid>
                <Grid item xs={12} className={classes.flexCenter}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={cguAccepted}
                        onChange={(e) => this.setState({cguAccepted: e.target.checked})}
                        value="cguAccepted"
                      />
                    }
                    label={<Typography variant="body2" style={{fontWeight: 'bold'}}>{t.cgu_first_lbl}</Typography>}
                  />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" style={{textAlign: 'center', fontWeight: 'bold'}}>{t.cgu_third_lbl}</Typography>
                    <RadioGroup
                      value={allowMailNotifications}
                      onChange={this.handleAllowMailNotifications}
                      className={classes.flexCenter}
                      style={{flexDirection: 'row'}}
                    >
                      <FormControlLabel value="yes" control={<Radio />} label={t.yes} />
                      <FormControlLabel value="no" control={<Radio />} label={t.no} />
                    </RadioGroup>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} style={{display: cguReaded ? 'none' : 'flex'}}>
                    <Icon className={classes.scrollDown}>keyboard_arrow_down</Icon>
                </Grid>
                <Grid item xs={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
                  <Btn
                      color="primary"
                      variant="raised"
                      onClick={this.validationCgu}
                      disabled={cguAccepted === false || allowMailNotifications === undefined}
                  >
                    {t.accept}
                  </Btn>
                </Grid>
              </Grid>
          </Page>
      </>
    )
  }


  @autobind
  private validationCgu(){
    const {enterprise, acceptCGU, toastError} = this.props
    acceptCGU(enterprise.id, {
      allow_mail_notifications: this.state.allowMailNotifications === 'yes' ? true : false
    }).then(() => {
        this.props.fetchInfos().then(() => {
          this.props.getEnterprise(enterprise.id);
          this.props.history.push({
            pathname: `/ptf/enterprise/${enterprise.id}`,
            state: { needRefesh: true }
          })
        })
    }).catch(err => toastError(err.msg))
  }
  
  @autobind
  private handleAllowMailNotifications(e){
    this.setState({ allowMailNotifications: e.target.value });
  }

  @autobind
  private handleScroll(e) {
    const element = e.target
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.setState({cguReaded: true})
    }
  }
 

}

const state2props = (state: RootState) => ({
  enterprises: state.accountInfo.enterprises,
  connectedUser: state.accountInfo.connectedUser,
  context: state.accountInfo.context,
  enterprise: state.accountInfo.enterpriseSelected,
})

const dispatch2props = (dispatch, ownProps: any) => ({
  fetchInfos: () => dispatch(fetchAccountInfos()),
  acceptCGU: (id: string, data: any) => dispatch(acceptCGU(id, data)),
  getEnterprise: (id: string) => dispatch(fetchEnterpriseSelected(id))
})

export default compose(
  withRouter,
  withI18n,
  withStyles(styles),
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
)(CguValidation)



// WEBPACK FOOTER //
// ./src/page/Consumer/CGU/CguValidation.tsx